import React from 'react';
import RemoteLoader from '../../components/RemoteLoader';
import runtimeConfig from '../../config';

const SortedReactPage = () => (
	<RemoteLoader
		url={runtimeConfig.remotes.sortedReact}
		scope="sortedreact"
		module="./SortedReactRemote"
	/>
);

export default SortedReactPage;
